// extracted by css-extract-rspack-plugin
module.exports =  {"instruction":"LicensePanel-hbDS__instruction","instruction-small":"LicensePanel-WCCE__instruction-small"};